<a *ngIf="link" [href]="link.url" target="_blank">
    <ng-container *ngIf="!link.title"> {{link.url}} </ng-container>
    {{ link.title }}
</a>
